import axios from 'axios';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import SkuListPage from './sku_list_page';
import { useDispatch } from 'react-redux';
import { setSelectedSkuReport } from '../../../../../store';
import { useNavigate } from 'react-router-dom';

const SkuReport = ({
    analysis_details_id,
    switchTab,
    order_details_id,
    isDefault
}) => {
  const navigate = useNavigate()
  const [skuReports, setSkuReports] = useState([]); // replace with your fetched data
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    minCustomers: 6,
    minOrders: 10,
  });
  const [showSkuList,setShowSkuList] = useState(false)
  const [defaultSkuReport, setDefaultSkuReport] = useState(null);


  const fetchSkuReports = async () => {
    try {
      setDefaultSkuReport(null)
      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}/skus/list-sku-reports?analysis_details_id=${analysis_details_id}&isDefault=${isDefault ? isDefault : false}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      if(isDefault){
        setShowSkuList(true);
        dispatch(setSelectedSkuReport(response.data.data[0]));
      }
      setSkuReports(response.data.data);
    } catch (err) {
      if (err.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error("Failed to fetch SKU reports");
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    if(switchTab === 4){
        fetchSkuReports()
        setShowSkuList(false)
      }
  },[switchTab])


  const set_Default_sku_report = async (id, isDefault = true) => {
    try{
      let url = `${process.env.REACT_APP_API_END_POINT}/skus/set-default-sku-report`
      const response = await axios.put(url, null, {
        params: {
          sku_report_id: id,
          isDeafult: isDefault,
          analysis_details_id: analysis_details_id
        }
      });
      setDefaultSkuReport({
        [id]: isDefault
      })
      toast.success('Default order updated successfully');
    }catch(error){
      if (error.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error('Failed to set default order');
    }
  };

  const handleCreate = async () => {
    try {
        let { title, description, minCustomers, minOrders } = formData;

        if(minCustomers > minOrders){
          toast.error("Please select Min Customers is less than Min Orders.")
          return;
        }

        // ✅ Basic Validation
        if (!title.trim() || !description.trim()) {
          toast.error("Title and description are required.");
          return;
        }
      
        minCustomers = parseInt(minCustomers);
        minOrders = parseInt(minOrders);
      
        if (isNaN(minCustomers) || minCustomers <= 0) {
            toast.error("Minimum customers must be a positive number.");
          return;
        }
      
        if (isNaN(minOrders) || minOrders <= 0) {
            toast.error("Minimum orders must be a positive number.");
          return;
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_END_POINT}/skus/create-sku-report`,
          {
            title: formData.title,
            description: formData.description,
            min_customer: parseInt(formData.minCustomers),
            min_order: parseInt(formData.minOrders),
            analysis_details_id: analysis_details_id
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
  
        toast.success("SKU Report created successfully!");
        setFormData({
          title: "",
          description: "",
          min_customers: "",
          min_orders: "",
        });
  
        fetchSkuReports();
        setShowModal(false)
  
      } catch (error) {
        if (error.response.data?.detail?.isExpireToken) {
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          navigate("/login")
        }
        toast.error("Failed to create SKU report.");
      } finally {
        // setLoading(false);
      }
  };

  return (
    <div className="">
      {
        !showSkuList &&
        <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold"></h1>
        <button
          onClick={() => setShowModal(true)}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          + Create SKU Report
        </button>
      </div>
      }

      {!showSkuList && skuReports.length > 0 && (
        <ul className="space-y-4">
          
          <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {skuReports.map((report, index) => {
          const isChecked = defaultSkuReport === null
            ? report.isDefault
            : defaultSkuReport[report._id] || false;


          return (
            <li
              key={index}
              className={`relative p-5 border rounded-2xl shadow-md transition hover:shadow-lg hover:bg-gray-50 cursor-pointer group ${
                isChecked ? "ring-2 ring-green-500" : ""
              }`}
              onClick={() => {
                setShowSkuList(true);
                dispatch(setSelectedSkuReport(report));
              }}
            >
              <div className="flex justify-between items-start mb-2">
                <h2 className="text-lg font-semibold text-gray-800 group-hover:text-green-600">
                  {report.title}
                </h2>
                <div onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    readOnly
                    className="accent-green-600 w-5 h-5 mt-1"
                    onClick={(e) => {
                      if (e.target.checked === false) return;
                      set_Default_sku_report(report._id, e.target.checked);
                    }}
                  />
                </div>
              </div>

              <p className="text-sm text-gray-600 mb-2">{report.description}</p>

              <div className="text-xs text-gray-500">
                <span className="inline-block mr-3">
                  👥 Min Customers: <strong>{report.min_customer}</strong>
                </span>
                <span>
                  📦 Min Orders: <strong>{report.min_order}</strong>
                </span>
              </div>
            </li>
          );
        })}
      </ul>

        </ul>
      )}
      {
        showSkuList &&
        <SkuListPage
          setShowSkuList={setShowSkuList}
          order_details_id={order_details_id}
        />
      }
      {
        skuReports.length === 0 &&
        <div className="text-gray-500 text-center mt-10">No SKU Report Found</div>
      }

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-lg">
            <h2 className="text-lg font-bold mb-4">Create SKU Report</h2>

            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium">Title</label>
                <input
                  type="text"
                  className="w-full border rounded px-3 py-2 mt-1"
                  value={formData.title}
                  onChange={(e) =>
                    setFormData({ ...formData, title: e.target.value })
                  }
                />
              </div>

              <div>
                <label className="text-sm font-medium">Description</label>
                <textarea
                  className="w-full border rounded px-3 py-2 mt-1"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                ></textarea>
              </div>

              <div className="flex gap-4">
                <div className="w-1/2">
                  <label className="text-sm font-medium">Min Customers</label>
                  <input
                    type="number"
                    min={1}
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.minCustomers}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        minCustomers: parseInt(e.target.value),
                      })
                    }
                  />
                </div>
                <div className="w-1/2">
                  <label className="text-sm font-medium">Min Orders</label>
                  <input
                    type="number"
                    min={1}
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.minOrders}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        minOrders: parseInt(e.target.value),
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="mt-6 flex justify-end gap-2">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={handleCreate}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Create
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SkuReport;
